import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "motion/react";

export function PageTransition({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const disableRouteMotion =
    pathname.startsWith("/workspace") || pathname === "/kol";

  if (disableRouteMotion) {
    return <div className="min-h-0 flex-1">{children}</div>;
  }

  return (
    <div className="min-h-0 flex-1">
      <AnimatePresence initial={false} mode="sync">
        <motion.div
          key={pathname}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          className="min-h-0 flex-1"
          exit={{
            opacity: 1,
            x: -10,
            scale: 0.996,
            transition: { duration: 0.16, ease: "easeOut" },
          }}
          initial={{ opacity: 1, x: 10, scale: 0.996 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
